document.addEventListener('DOMContentLoaded', () => {
	parallaxFeature()
})

// Re-initialize when sections are added/updated in Theme Editor
if (Shopify && Shopify.designMode) {
	document.addEventListener('shopify:section:load', parallaxFeature)
	document.addEventListener('shopify:section:unload', parallaxFeature) // optional cleanup trigger
}

function parallaxFeature() {
	const parallaxWrappers = document.querySelectorAll('.js-parallax-wrapper')
	if (parallaxWrappers.length === 0) return

	let ticking = false
	let scrollHandler = null
	let mediaQuery = window.matchMedia('(min-width: 1000px)')
	let mediaListener = null
	let resizeTimeout = null

	// Always reset transforms (ensures no leftover parallax on mobile)
	const resetTransforms = () => {
		parallaxWrappers.forEach(wrapper => {
			wrapper.style.transform = ''
		})
	}

	const updateParallax = () => {
		parallaxWrappers.forEach(wrapper => {
			const rect = wrapper.getBoundingClientRect()
			const windowHeight = window.innerHeight
			const wrapperCenter = rect.top + rect.height / 2
			const parallaxAmount = parseFloat(wrapper.dataset.parallaxAmount) || 15

			if (rect.bottom >= -200 && rect.top <= windowHeight + 200) {
				const distanceFromCenter = wrapperCenter - windowHeight / 2
				const translateY = distanceFromCenter * (parallaxAmount / 100)
				wrapper.style.transform = `translateY(${translateY}px)`
			}
			// else: leave current transform (or could reset if preferred)
		})

		ticking = false
	}

	const requestTick = () => {
		if (!ticking) {
			requestAnimationFrame(updateParallax)
			ticking = true
		}
	}

	const enableParallax = () => {
		// Ensure clean start (in case we just came from mobile)
		resetTransforms()

		if (!scrollHandler) {
			scrollHandler = () => requestTick()
			window.addEventListener('scroll', scrollHandler, { passive: true })
		}

		requestTick() // initial position
	}

	const disableParallax = () => {
		resetTransforms()

		if (scrollHandler) {
			window.removeEventListener('scroll', scrollHandler, { passive: true })
			scrollHandler = null
		}
		ticking = false
	}

	// Primary: matchMedia listener (most accurate)
	const handleMediaChange = (e) => {
		if (e.matches) {
			enableParallax()
		} else {
			disableParallax()
		}
	}

	// Secondary: resize fallback (catches any missed transitions, e.g. fast resize + zoom)
	const handleResize = () => {
		clearTimeout(resizeTimeout)
		resizeTimeout = setTimeout(() => {
			if (window.innerWidth < 1000) {
				disableParallax()
			} else if (mediaQuery.matches) {
				enableParallax()
			}
		}, 100) // small debounce
	}

	// === Cleanup old listeners (critical for Shopify editor re-inits) ===
	if (mediaListener) {
		mediaQuery.removeEventListener('change', mediaListener)
	}
	if (scrollHandler) {
		window.removeEventListener('scroll', scrollHandler, { passive: true })
	}
	window.removeEventListener('resize', handleResize)

	// === Set up new listeners ===
	mediaListener = handleMediaChange
	mediaQuery.addEventListener('change', mediaListener)
	window.addEventListener('resize', handleResize)

	// Initial state
	if (mediaQuery.matches) {
		enableParallax()
	} else {
		disableParallax()
	}
}
